import { WatchlistBaseModel } from '../../domain/watchlist/WatchlistDomains';

export interface WatchlistState {
  watchlist: WatchlistBaseModel | undefined;
  changed: boolean;
}

const initialState: WatchlistState = {
  watchlist: undefined,
  changed: false,
};

export const watchlistReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'CHANGE_DATA_WATCHLIST':
      return { ...state, watchlist: action.payload, changed: true };
    case 'CLEAR_WATCHLIST':
      return { ...state, watchlist: undefined, changed: false };
    default:
      return state;
  }
};
